'use client';

import classNames from 'classnames';
import { useState } from 'react';
import { InnerContainer } from '../common/inner-container';
import Heading from '../heading';

export interface Tab {
  title: string;
  content: React.ReactNode | string;
  useHtml?: boolean;
}
type Props = {
  tabs: Tab[];
};

export const SimpleTabs: React.FC<Props> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <InnerContainer className="gap relative flex flex-row overflow-auto border-b" data-testid="content-title-area">
        {tabs.map((item, idx) => (
          <Heading
            tagType="h2"
            cls={classNames(
              'items-center border-b-4 border-purple500 px-10 pb-4 cursor-pointer select-none whitespace-nowrap z-10',
              [
                activeTab === idx
                  ? 'font-bold text-purple500 border-purple500 md:text-base text-sm'
                  : 'text-black700 border-transparent md:text-base text-sm',
              ]
            )}
            key={item.title}
            onclick={() => setActiveTab(idx)}
            data-testid="title"
          >
            {item.title}
          </Heading>
        ))}
      </InnerContainer>
      {tabs.map((item, idx) => (
        <div
          key={item.title + idx}
          data-testid="credit-info-content"
          className={classNames('mt-5 overflow-auto text-sm text-black800 md:text-base', {
            hidden: activeTab !== idx,
          })}
        >
          {item.useHtml ? (
            <div
              className="table-list-formatting"
              dangerouslySetInnerHTML={{
                __html: item.content as string,
              }}
              data-testid="content"
            />
          ) : (
            <div className="table-list-formatting container mx-auto" data-testid="content">
              {item.content}
            </div>
          )}
        </div>
      ))}
    </>
  );
};
